import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import "./styles/bestand.css";
// NACH bestand.css, nicht davor: die bewussten Uebergaenge (Spec, "Bewusste Verbesserungen",
// Punkt 3) muessen die woertlich uebernommenen Bestandsregeln ueberschreiben koennen, nicht
// umgekehrt.
//
// Dieser Import fehlte bis zum 2026-08-10 - gefunden erst beim Abschluss der Phase 6 (Task 29).
// Die Datei war geschrieben, ihr Test gruen und ihre Regel im ausgelieferten CSS NICHT vorhanden:
// `test/komponenten/Board/uebergaenge.test.ts` liest sie per readFileSync VON DER PLATTE und ist
// deshalb gruen, ganz unabhaengig davon, ob das Stylesheet je ausgeliefert wird. Der Buendelwaechter
// (`test/reference/bundle.test.ts`) hatte den Befund eingefroren und ausdruecklich vermerkt, dass er
// rot wird, sobald jemand den Import nachzieht - genau das ist hier passiert, und der Fall ist
// entsprechend auf eine ANWESENHEITSPRUEFUNG umgestellt.
//
// Zum Umfang, damit niemand mehr erwartet als drinsteht: die Datei traegt heute EINEN der vier
// Uebergaenge der Spec (`board-zeile`). Die drei uebrigen fehlen weiterhin.
import "./styles/uebergaenge.css";
// NACH `uebergaenge.css`: die Flaechen ohne Bestandsvorbild (Lieferanten, Suchfelder). Sie duerfen
// Bestandsregeln ueberschreiben - `.field input` aus `bestand.css:626` etwa hat dieselbe
// Spezifitaet wie `.jtl-suchfeld input` (Nachfahrenselektor seit Fixrunde 1, siehe `suchfeld.css`
// - den Kindkombinator `.jtl-suchfeld > input` gibt es seither nicht mehr), und nur die
// Reihenfolge entscheidet.
//
// Zwei Dateien statt einer, weil sie verschiedene Reichweiten haben: `suchfeld.css` kleidet DREI
// Bauarten in drei Modulen, `lieferanten.css` gehoert einer einzigen Flaeche.
import "./styles/neubau/suchfeld.css";
import "./styles/neubau/lieferanten.css";
// Der einheitliche Seitenkopf (bewusste Abweichung vom Bestand, 2026-08-13). Muss NACH
// `bestand.css` stehen: `.seitenkopf` lebt zwar unter eigenen Klassennamen, das Bestandsblatt
// setzt aber `* { margin: 0 }` und mehrere Seitenrahmen, auf denen dieser Kopf aufsitzt.
import "./styles/neubau/seitenkopf.css";
// `Artikelbild`/das Grossbild-Overlay (Auftrag 1, 2026-08-20) - ebenfalls ohne Bestandsvorbild.
// Der Einbau in die Tabellen (Auftrag 2 und 4) ist inzwischen geschehen.
import "./styles/neubau/artikelbild.css";
// Der Zeitstrahl im Reiter "Spedition" (`ship-stationen-liste`/`ship-station-*`) - ebenfalls ohne
// Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/stationen.css";
// Das Panel "Terminaenderungen" der Uebersicht (Auftrag F) - ebenfalls ohne Bestandsvorbild, siehe
// Kopfkommentar der Datei.
import "./styles/neubau/terminaenderungen.css";
// Die Zeitstrahl-Zeile (Auftrag 2, "sprechende Zeile, Artikelstreifen, Positions-Popup") - dritte
// Spalte, Artikelstreifen, Positionen-Popup, alle drei ohne Bestandsvorbild. Die drei Fragmente
// bewahren hier die urspruengliche Regelreihenfolge; siehe ihre Abschnittskommentare.
import "./styles/neubau/zeitstrahlZeile.css";
import "./styles/neubau/zeitstrahlArtikelPositionen.css";
import "./styles/neubau/zeitstrahlStationen.css";
// Echte Anker (Aufgabe 5, Tieflinks): die fuenf Navigationsreiter und die sechs Oeffnen-Stellen
// tragen seither ein `<a href>` statt eines `<button>`/`<div onClick>` - der Bestand kannte an
// keiner dieser Stellen einen Anker, siehe Kopfkommentar der Datei.
import "./styles/neubau/tieflinks.css";
// Die Hervorhebung eines verlinkten Dokuments im Dokumente-Reiter (Aufgabe 7, Tieflinks) - ebenfalls
// ohne Bestandsvorbild: der Reiter kannte vor dieser Aufgabe keinen Auswahlzustand, siehe
// Kopfkommentar der Datei.
import "./styles/neubau/hervorhebung.css";
// Kurze Hervorhebung des Drawer-Abschnitts nach dem Sprung aus einer nicht aenderbaren Grid-Zelle
// (`lib/zellZiel.ts`) - ohne Bestandsvorbild.
import "./styles/neubau/abschnittSprung.css";
// Tokenquelle der drei Lieferstatus-Farben (Auftrag "Lieferstatus-Icons + Uhrzeit", 2026-08-28) -
// `anlieferung.css` referenziert ausschliesslich `var(--liefer-status-*)` daraus (siehe
// Kopfkommentar der Datei, warum eine eigene Tokenquelle statt fester Farben dort). Die Reihenfolge
// der beiden Importe ist fachlich EGAL (Nachbesserung, Pruefung Punkt 8): CSS Custom Properties
// werden zur NUTZUNGSZEIT aufgeloest (Cascade auf dem Element, nicht Textreihenfolge im
// Stylesheet) - anders als bei echten Ueberschreibungsregeln (siehe z. B. den Kommentar an
// `vorlagenZeilenZiehen.css` weiter unten, wo die Reihenfolge tatsaechlich zaehlt). Trotzdem hier
// bewusst VOR `anlieferung.css` einsortiert, rein als Lesereihenfolge (Quelle vor Verbraucher).
import "./styles/neubau/lieferAmpel.css";
// Der Reiter "Anlieferung" (Auftrag "Reiter Anlieferung", 2026-08-26) - Positions- und
// Einbuchungsliste, ebenfalls ohne Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/anlieferung.css";
// EU/China-Faehnchen und Laenderfilter im Bestellboard - ebenfalls ohne Bestandsvorbild, siehe
// Kopfkommentar der Datei. Muss NACH `bestand.css` stehen, wie jede Datei in dieser Gruppe: die
// Chips greifen auf `.order-list-toolbar`-Nachbarn zu (`.order-list-clear-filters` u. a.), deren
// Grundregeln aus dem Bestandsblatt kommen.
import "./styles/neubau/laenderfilter.css";
// Der Ziehgriff der Standardaufgaben in "Task-Template verwalten" (Auftrag "Standardaufgaben lassen
// sich umsortieren", 2026-08-27) - MUSS NACH `bestand.css` stehen: die Datei ueberschreibt u. a.
// `.task-template-row`s `grid-template-columns` (bestand.css:3530) um eine vierte Spalte, siehe
// Kopfkommentar der Datei.
import "./styles/neubau/vorlagenZeilenZiehen.css";
// Der Land-Reiter (EU/China) ganz oben in "Task-Template verwalten" (Auftrag "Taskvorlagen je Land
// (EU/China) getrennt pflegbar", 2026-09-01) - ebenfalls ohne Bestandsvorbild, siehe Kopfkommentar
// der Datei. Reihenfolge relativ zu `vorlagenZeilenZiehen.css` ist fachlich egal (beide betreffen
// unterschiedliche Klassennamen), hier nur als Lesereihenfolge direkt danach einsortiert.
import "./styles/neubau/vorlagenLandReiter.css";
// `JtlLoeschDialog` (Aufgabe "EK-Bestellung in JTL loeschen") - Breite und Feldgestaltung ohne
// Bestandsvorbild, siehe Kopfkommentar der Datei. Im Drawer verdrahtet.
import "./styles/neubau/jtlLoeschDialog.css";
// Feldzustand-Optik (Auftrag 0, Fundament) - gesperrte/erwartete Formularfelder im Drawer, siehe
// Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen: die Light-Mode-`:disabled`-Regel darin
// ueberschreibt bewusst per Kaskade, weil `bestand.css` selbst Paritaetstest-gesperrt ist (siehe
// Kopfkommentar `feldzustand.css`). Verdrahtung an den einzelnen Feldern ist Sache der
// Folgeauftraege je Tab-Datei.
import "./styles/neubau/feldzustand.css";
// Der schwebende Lade-Hinweis (Auftrag "Schwebender Lade-Hinweis (Spinner-Popup) statt Textzeile",
// 2026-08-28) - eigene Id, ohne Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/ladeHinweis.css";
// Mehrfachauswahl auf der Bestellübersicht (Strg/Shift-Klick, Auftrag "Auf der Bestellübersicht
// Sammeländerungen für Status und Bereich markieren", 2026-09-01) - ebenfalls ohne Bestandsvorbild,
// siehe Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen: `.order-list-row-selected` teilt
// sich die Spezifitaet mit `tr.list-recent td`/`tr:hover td` aus dem Bestandsblatt, und nur die
// spaetere Quellposition entscheidet (siehe Kopfkommentar der Datei).
import "./styles/neubau/mehrfachauswahl.css";
// In JTL geloeschte Bestellzeilen (Auftrag 07, E4, 2026-09-05) - streng schreibgeschuetzte Zeilen
// samt Anzeige „In JTL geloescht", ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH
// `bestand.css` UND nach `mehrfachauswahl.css` stehen: die Zeile traegt beide Klassen gleichzeitig
// (`order-list-row-selected` + `order-list-row-deleted`), und nur die spaetere Quellposition
// entscheidet bei gleicher Spezifitaet.
import "./styles/neubau/jtlGeloeschtZeile.css";
// Sammel-Statuswechsel auf der Bestellübersicht (Auftrag "Auf der Bestellübersicht
// Sammeländerungen für Status und Bereich", 2026-09-01) - `Board/SammelStatusDialog.tsx`, ebenfalls
// ohne Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/sammelStatusDialog.css";
// Sammelsendung im Bestellboard (Task 6, Elternzeile/Klammer) - ebenfalls ohne Bestandsvorbild,
// siehe Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen.
import "./styles/neubau/sammelsendung.css";
// Teillieferung im Bestellboard (Damian, 16.10.2026): ganze Zeile orange, plus die Tokens `--orange` und
// `--orange-soft` (hell/dunkel) - ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH `bestand.css`
// stehen (Hover-/Recent-Regeln der Zeilen).
import "./styles/neubau/teillieferung.css";
// Die vier Spaltenfilter-Widgets (Auftrag "Bestellboard-Filter datentypgerecht bauen", 2026-09-01) -
// ebenfalls ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen: die
// Widgets stehen INNERHALB von `.order-list-filter-menu` (bestand.css:2128-2140) und nutzen dessen
// Rahmen/Label-/Knopf-Grundstil weiter, kleiden nur ihren eigenen neuen Inhalt.
import "./styles/neubau/spaltenfilter.css";
// Der Reiter "Historie" (Auftrag "Bestellungs-Aenderungshistorie", Task 11, Nachbesserung
// 2026-09-05) - Aufklapp-Schalter/-Liste fuer Sammel-Ereignisse, ebenfalls ohne Bestandsvorbild,
// siehe Kopfkommentar der Datei. War zunaechst faelschlich direkt in `bestand.css` ergaenzt (bricht
// `test/reference/stylesheet.test.ts` und verschwindet beim naechsten `gen:stylesheet`-Lauf), jetzt
// wie jeder andere Reiter hier eingebunden.
import "./styles/neubau/historieReiter.css";
// Die Positions-Produktionsbild-Galerie hat kein Vorbild im aus `index.html` generierten Bestand.
// Ihr eigenes Stylesheet muss deshalb nach `bestand.css` geladen werden; siehe Kopfkommentar dort.
import "./styles/neubau/produktionsbilderGalerie.css";
// Zellkuerzung auf der Bestellübersicht (Fehlerbericht 2026-09-06: Werte liefen über die
// Spaltenbreite hinweg) - ebenfalls ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH
// `bestand.css` stehen: ueberschreibt dessen generische `th`/`td`-Regel bei gleicher Spezifitaet.
import "./styles/neubau/zellkuerzung.css";
// Bestellkennung je Zeile der frueheren Kachel "Letzte Aktivitäten" (Auftrag "Übersichtsseite -
// Untertitel, Bestellbezug, Lieferant bei Terminänderungen, Breiten-Check", 06.09.2026) - ebenfalls
// ohne Bestandsvorbild. Die Kachel ist mit der Seite "Aktivitäten" entfallen; die Regeln bleiben,
// weil `splitMarke.css` und `test/visual/splitMarkeLayout.spec.ts` sie voraussetzen, siehe
// Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen: ergaenzt dessen `.ops-history-row`-Grid
// um eine vierte Spalte bei gleicher Selektorspezifitaet.
import "./styles/neubau/historieBestellbezug.css";
// Der Reichweite-Dialog beim Dokumenten-Upload (Sammelsendung, Task 4b, Fixrunde 1) - ebenfalls
// ohne Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/reichweiteAuswahl.css";
// Kennzeichnung geerbter Sendungsdokumente im Drawer (Sammelsendung, Task 6) - ebenfalls ohne
// Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/geerbtHinweis.css";
// Abschnitt „Entfernte Dokumente“ im Reiter Dokumente (Spec 2026-10-16) - ebenfalls ohne
// Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/dokumentEntfernen.css";
// Liste „Gelöste Zahlungsbelege“ im Reiter Zahlung (Ticket H, Review W1) - ebenfalls ohne Bestandsvorbild, siehe
// Kopfkommentar der Datei.
import "./styles/neubau/zahlungsbelegeGeloest.css";
// `LineageHinweis` (Task 11/12, `Drawer/LineageHinweis.tsx`) plus `.partial-delivery-copy-options`
// (Task 9, `NewOrder/TeillieferungDialog.tsx`) - nachgezogen erst in der Endabnahme-Fixrunde
// (Pflichtreview-Entscheidung "JA, jetzt"), ebenfalls ohne Bestandsvorbild, siehe Kopfkommentar der
// Datei.
import "./styles/neubau/lineage.css";
// Split-Kennzeichnung neben der Bestellnummer (`SplitMarke.tsx`), ebenfalls ohne Bestandsvorbild.
import "./styles/neubau/splitMarke.css";
// Stock-Marke neben der Bestellnummer (`StockMarke.tsx`), ebenfalls ohne Bestandsvorbild.
import "./styles/neubau/stockMarke.css";
// Marke "Neu" an Bestellungen mit neuen Artikeln (`NeuerArtikelMarke.tsx`), ebenfalls ohne Bestandsvorbild.
import "./styles/neubau/neuerArtikelMarke.css";
// Toter Zahlungen-Filter-Button entfernt (Auftrag, 2026-09-07): `ZahlungsansichtVariante.tsx`
// zeichnet den einzigen Filter der Zahlungsrolle seither als reine `<span>`-Anzeige statt als
// wirkungslose `<button onClick={() => {}}>`-Attrappe, ebenfalls ohne Bestandsvorbild, siehe
// Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen: `.ops-filter-static` ueberschreibt
// dessen `cursor: pointer` bei gleicher Selektorspezifitaet.
import "./styles/neubau/zahlungsfilterAnzeige.css";
// Positionsbezogene Artwork-/Produktionsbild-Aktionen im Grid (Task 1) - eigene SPA-Klassen ohne
// Bestandsvorbild, daher bewusst nach `bestand.css` aus einem Neubau-Blatt geladen.
import "./styles/neubau/positionsdokumentAktionen.css";
import "./styles/neubau/positionsdokumente.css";
// Artwork-Prüfung am Artwork im Reiter Dokumente (Abzeichen, Dialog mit den Einzelheiten; Artwork-Abgleich, Task 10),
// ohne Bestandsvorbild. MUSS NACH `bestand.css` stehen: die Breite des Dialogs übersteuert dessen `.overwrite-dialog`.
import "./styles/neubau/artwork-pruefung.css";
import "./styles/neubau/fxKurssicherung.css";
import "./styles/neubau/zahlungsseiteTabellen.css";
// Zustandskaestchen der Werkzeugleiste, ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH
// `bestand.css` stehen: uebersteuert dessen `.order-list-toolbar input` (360px breit, margin-left:auto).
import "./styles/neubau/zustandsfilter.css";
// Seite "Zahlungsvorlagen", ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH `bestand.css` stehen.
import "./styles/neubau/zahlungsvorlagen.css";

// Zahlungsziel-<select> wie die uebrigen Eingabefelder, siehe Kopfkommentar der Datei. MUSS NACH
// `bestand.css` stehen: ergaenzt dessen `.pay-terms-row input`-Regeln um `select`.
import "./styles/neubau/zahlungszielAuswahl.css";
// Haekchen-Felder im Drawer (Stock Order, Liefertermine fixiert), ohne Bestandsvorbild; MUSS NACH
// `bestand.css` stehen (`.field input` macht sonst jedes Haekchen volle Breite).
import "./styles/neubau/haken-felder.css";

// Liquiditaetsplanung (Kacheln, Wochendiagramm-Ergaenzungen, Ratentabelle), siehe Kopfkommentar der
// Datei. MUSS NACH `bestand.css` stehen: ergaenzt die `.fx-week-chart-*`-Regeln fuer Knopf-Gruppen.
import "./styles/neubau/liquiditaet.css";

// Seite "Aktivitaeten" (Tabelle, Kopfleiste, Seitenbehaelter), siehe Kopfkommentar der Datei. MUSS
// NACH `bestand.css` stehen: ergaenzt dessen `table.ov`-Regeln.
import "./styles/neubau/aktivitaeten.css";

// Zahlungsplan im Reiter "Zahlung" (Nach Plan / Individuell), siehe Kopfkommentar der Datei. MUSS NACH `bestand.css`
// stehen: ergaenzt dessen `.payment-share`-Regeln.
import "./styles/neubau/zahlungsplan.css";
// Dialog "Split rueckgaengig machen", ohne Bestandsvorbild. MUSS NACH `bestand.css` stehen.
import "./styles/neubau/splitRueckgaengig.css";
// Marken-Menue "Zuletzt aktiv" (Zeitangabe statt Punkt, Hinweis im Kopf), ohne Bestandsvorbild. MUSS NACH
// `bestand.css` stehen: ergaenzt dessen `.brand-user-*`-Regeln.
import "./styles/neubau/zuletztAktiv.css";
// Der Fehlerstapel (`FehlerStapel.tsx`, Fehleranzeige Paket 1, Spec 2026-10-19) - zweiter
// Meldungskanal neben dem Toast, ohne Bestandsvorbild, siehe Kopfkommentar der Datei. Reihenfolge
// fachlich egal: eigene Klassennamen (`.fehler-stapel*`), keine Bestandsregel wird ueberschrieben; die
// Bloecke darunter (positionenAnzahl, wareEingebucht, upload) stehen dahinter und sind davon unabhaengig.
// Ohne diesen Import stuende das Stylesheet auf der Platte, und der Stapel erschiene ungestaltet am
// Seitenende (siehe `uebergaenge.css` oben).
import "./styles/neubau/fehlerStapel.css";
// Zeile "Anzahl Positionen: N" unter der Positionsliste im Reiter "Bestellung", ohne Bestandsvorbild. MUSS
// NACH `bestand.css` stehen: ergaenzt dessen `.items-legend`-Zeile darueber.
import "./styles/neubau/positionenAnzahl.css";
// Spalte "Ware eingebucht" (Pille mit Datum, Zustandsfilter, Auftrag 2026-10-20), ohne Bestandsvorbild. MUSS NACH
// `bestand.css` stehen: hebt dessen 180px-Grenze der `.order-list-pill` fuer die Pille mit Datum auf.
import "./styles/neubau/wareEingebucht.css";
// Upload-Anzeige (Fortschrittszeile, stehende Fehlermeldungen, stehende Hinweise unten rechts,
// Task 4 "Uploads bis 100 MB"), ohne Bestandsvorbild, siehe Kopfkommentar der Datei.
import "./styles/neubau/upload.css";
// Die gemeinsame Ladefehler-Flaeche (`Ladefehler.tsx`, Fehleranzeige Paket 2, Regel L1): Text samt Ursache und
// "Erneut laden" statt des Leertexts, ohne Bestandsvorbild. MUSS NACH `bestand.css` stehen: nutzt dessen
// `.btn-ghost` und die Farbtokens.
import "./styles/neubau/ladefehler.css";
// Die Leiste nach einer Unterbrechung der Live-Verbindung (`VerbindungsLuecke.tsx`, Lueckenausgleich), ohne Bestandsvorbild.
// MUSS NACH `bestand.css` stehen: nutzt dessen `.btn-sec`, `.btn-ghost` und die Farbtokens.
import "./styles/neubau/verbindungsluecke.css";
// Die gemeinsame Klasse `.visuell-versteckt` (Ansage-Regionen der Uploads, versteckte Dateifelder), ohne Bestandsvorbild,
// siehe Kopfkommentar der Datei. Reihenfolge fachlich egal: eine eigene Klasse, keine Bestandsregel wird ueberschrieben.
import "./styles/neubau/visuellVersteckt.css";
// Der Knopf „Zollinstruktionen anstoßen“ samt Plakette (`ZollKnopf.tsx` hinter `ZollKnopfLazy.tsx`, Reiter Spedition und Sammelsendungs-Drawer, Plan
// „Zollinstruktionen im Hub“, Task 11), ohne Bestandsvorbild. MUSS NACH `bestand.css` stehen: hebt dessen 180px-Grenze der
// `.order-list-pill` fuer die Plakette auf. Eigene Datei, nicht `zollinstruktionen.css`: die laedt nur der nachgeladene Dialog.
import "./styles/neubau/zollKnopf.css";
// Reiter "Dashboard" (Anlieferungen fuer die Lagerplanung, 2026-10-30): Kennzahlen, Sendungskacheln, Standzeile, ohne
// Bestandsvorbild, siehe Kopfkommentar der Datei. Aus dem Einstieg geladen, nicht aus dem nachgeladenen Seitenmodul
// (`DashboardPage/DashboardSeite.tsx` importiert kein CSS). MUSS NACH `bestand.css` stehen: baut auf `.page` und dem
// globalen `* { margin: 0 }` auf; die Klassen tragen alle das Praefix `dash-`, es gibt keine Ueberschneidung.
import "./styles/neubau/dashboard.css";
// Erlauben-Seite und "Meine KI-Zugaenge" (KI-Zugang, Stufe 1), ohne Bestandsvorbild, siehe Kopfkommentar der Datei. MUSS NACH
// `bestand.css` stehen: nutzt dessen `table.ov`, `.btn-primary`, `.btn-sec` und die Farbtokens. Das Stylesheet liegt im Eintritt (die
// Seitenbehaelter `#page-ki-*` stehen in `App.tsx`), die Seiten selbst im nachgeladenen Chunk `KiZugangSeiten`.
import "./styles/neubau/ki-zugang.css";

/**
 * Montagepunkt der SPA ist `document.body` SELBST - kein `<div id="wurzel">`.
 *
 * Begruendung (Woertlichkeitsregel der Portierung): `index.html` (Bestand) haelt im `<body>` direkt
 * `<header>`, `<main>`, die Dialoge und das Overlay. Ein zusaetzlicher Montagecontainer waere ein
 * Knoten, den das Original nicht hat - und damit die allererste Abweichung in JEDER
 * Ganzseiten-Signatur (`test/visual/signatur.ts`, Vorgabeselektor `"body"` in
 * `test/visual/harness.ts`). Er zu ueberspringen hiesse, den Vergleich nachsichtiger zu machen;
 * ihn wegzulassen beseitigt die Abweichung.
 *
 * Dass das traegt, ist keine Annahme, sondern steht in React 19 ausdruecklich so im Code:
 * `createRoot` prueft nur `isValidContainer`, warnt fuer `document.body` NICHT (die alte Warnung
 * "Rendering components directly into document.body is discouraged" gehoerte zum entfernten
 * `ReactDOM.render`), und die Erstmontage raeumt den Container ueber `clearContainerSparingly` -
 * eine Funktion, die `HTML`/`HEAD`/`BODY` eigens behandelt und `SCRIPT`, `STYLE` sowie
 * `<link rel="stylesheet">` bewusst STEHEN laesst
 * (`react-dom/cjs/react-dom-client.development.js`). Ein im `<body>` stehendes Modul-Skript
 * ueberlebt die Montage also; hier steht es ohnehin im `<head>` (siehe `index.html`).
 *
 * `document.body` ist zu diesem Zeitpunkt garantiert vorhanden: `type="module"` impliziert `defer`,
 * das Skript laeuft erst nach dem Parsen des Dokuments. Der Wurf unten ist trotzdem kein toter Code
 * - er faengt den einen Fall ab, in dem jemand das Skript ohne `type="module"` in den `<head>`
 * zoege, und sagt dann, was los ist, statt React mit `null` zu fuettern.
 */
const wurzelKnoten = document.body;
if (!wurzelKnoten) {
  throw new Error(
    "document.body fehlt beim Start - laeuft das Einstiegsskript ohne type=\"module\" im <head>?",
  );
}

// `onRecoverableError`: einen Renderfehler, den React selbst behoben hat (der Neuversuch gelang),
// meldet React sonst ueber `reportError` - der globale Fehlerfaenger zeigte dann "Unerwarteter
// Fehler", obwohl die Flaeche stimmt (Review Task 3, Fehleranzeige Paket 1). Er gehoert nur in die
// Konsole.
createRoot(wurzelKnoten, {
  onRecoverableError: (fehler) => console.error("Von React wiederhergestellt:", fehler),
}).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
